import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

export default function EmptyState({ onStartNewImport }) {
  return (
    <Panel className="dashed-border m-0 text-center" name="empty-state">
      <Panel.Body>
        <h4 className="text-muted mb-4">
          You haven't imported anything yet
        </h4>
        <button className="btn btn-blue" onClick={onStartNewImport}>
          Start your first import
        </button>        
      </Panel.Body>
    </Panel>
  );
}

EmptyState.propTypes = {
  onStartNewImport: PropTypes.func.isRequired
};
